import {
  SURVEY_APPROVAL,
  SURVEY_APPROVAL_OPTIONS,
  SURVEY_STATUS,
  STATUS_OPTIONS,
  QUESTION_TYPE_OPTIONS,
  OPTION_TYPES,
  OPTION_TYPE_OPTIONS,
  INPUT_TYPES,
  INPUT_TYPE_OPTIONS,
  REQUIRED_OPTIONS,
} from '../../constants/survey';

export const getSurveyFormFields = () => [
  { type: 'divider', label: 'Thông tin cơ bản' },
  {
    name: 'title',
    label: 'Tiêu đề Survey',
    type: 'input',
    rules: [{ required: true, message: 'Vui lòng nhập tiêu đề' }],
    placeholder: 'Ví dụ: Khảo sát ý kiến người dùng 2024',
  },
  {
    name: 'description',
    label: 'Mô tả',
    type: 'textarea',
    rows: 2,
    placeholder: 'Nhập mô tả chi tiết về khảo sát...',
  },
  {
    name: 'status',
    label: 'Trạng thái',
    type: 'select',
    md: 12,
    options: SURVEY_APPROVAL_OPTIONS,
    defaultValue: SURVEY_APPROVAL.PENDING,
  },

  { type: 'divider', label: 'Danh sách câu hỏi' },
  {
    name: 'questions',
    type: 'group',
    titleButtonAdd: 'Thêm câu hỏi mới',
    isSort: true,
    isCollapse: true,
    headerField: 'title',
    filedsList: [
      {
        name: 'title',
        label: 'Nội dung câu hỏi',
        type: 'input',
        rules: [{ required: true }],
        span: 16,
      },
      {
        name: 'type',
        label: 'Loại câu hỏi',
        type: 'select',
        options: QUESTION_TYPE_OPTIONS,
        rules: [{ required: true }],
        span: 8,
      },
      {
        name: 'is_required',
        label: 'Bắt buộc',
        type: 'select',
        options: REQUIRED_OPTIONS,
        span: 4,
        defaultValue: 1,
      },
      {
        name: 'sort_order',
        label: 'Thứ tự',
        type: 'number',
        span: 4,
      },
      {
        name: 'text_hint',
        label: 'Gợi ý nhập liệu (Placeholder)',
        type: 'input',
        span: 16,
      },
      {
        name: 'description',
        label: 'Mô tả chi tiết câu hỏi',
        type: 'textarea',
        rows: 1,
        span: 24,
      },
      // Cấu hình đặc thù cho loại Slider (Type 7) / Rating
      { type: 'divider', label: 'Cấu hình đặc thù (Slider/Rating)', span: 24 },
      { name: 'min_value', label: 'Min', type: 'number', span: 4 },
      { name: 'max_value', label: 'Max', type: 'number', span: 4 },
      { name: 'default_value', label: 'Mặc định', type: 'number', span: 4 },
      { name: 'step', label: 'Bước nhảy', type: 'number', span: 4 },
      { name: 'unit', label: 'Đơn vị', type: 'input', span: 4 },
      {
        name: 'status',
        label: 'Trạng thái',
        type: 'select',
        options: STATUS_OPTIONS,
        span: 4,
        defaultValue: SURVEY_STATUS.ACTIVE,
      },

      { type: 'divider', label: 'Danh sách lựa chọn (Options)', span: 24 },
      {
        name: 'options',
        type: 'group',
        titleButtonAdd: 'Thêm lựa chọn',
        isSort: true,
        isCollapse: true,
        headerField: 'label',
        span: 24,
        filedsList: [
          {
            name: 'label',
            label: 'Nhãn lựa chọn (Label)',
            type: 'input',
            span: 8,
            rules: [{ required: true, message: 'Vui lòng nhập nhãn!' }],
            placeholder: 'VD: Ý kiến khác',
          },
          {
            name: 'value',
            label: 'Giá trị (Value)',
            type: 'input',
            span: 6,
            rules: [{ required: true, message: 'Vui lòng nhập giá trị!' }],
            placeholder: 'VD: other',
          },
          {
            name: 'option_type',
            label: 'Kiểu lựa chọn',
            type: 'select',
            options: OPTION_TYPE_OPTIONS,
            span: 6,
            defaultValue: OPTION_TYPES.TEXT,
          },
          {
            name: 'sort_order',
            label: 'Thứ tự',
            type: 'number',
            span: 4,
          },
          {
            name: 'input_type',
            label: 'Kiểu ô nhập (Input Type)',
            type: 'select',
            options: INPUT_TYPE_OPTIONS,
            span: 6,
            defaultValue: INPUT_TYPES.NONE,
          },
          {
            name: 'text_hint',
            label: 'Gợi ý ô nhập (Placeholder)',
            type: 'input',
            span: 8,
            placeholder: 'VD: Nhập nội dung góp ý của bạn...',
          },
          {
            name: 'status',
            label: 'Trạng thái',
            type: 'select',
            options: STATUS_OPTIONS,
            span: 5,
            defaultValue: SURVEY_STATUS.ACTIVE,
          },
          {
            name: 'default_value',
            label: 'Mặc định (Số)',
            type: 'number',
            span: 5,
          },
          { name: 'min_value', label: 'Min', type: 'number', span: 6 },
          { name: 'max_value', label: 'Max', type: 'number', span: 6 },
          { name: 'step', label: 'Step', type: 'number', span: 6 },
          { name: 'unit', label: 'Đơn vị', type: 'input', span: 6 },
        ],
      },
    ],
  },
];
